import React, { useEffect, useState } from "react";
import { UpcomingBooking } from "./UpcomingBooking";
import RevenueChart from "./RevenvueChart";
import { monthsData, yearData } from "@/constants/dashboardData";
import { API_ROUTES } from "@/services/environment";
import { GET } from "@/services/api";
import { useAppSelector } from "@/hooks/hook";
import PackagePriceCalculator from "./PackagePriceCalculator";
import { USFormatePriceWithoutDecimal } from "@thdinc/hpf-shared";

export const Dashboard = () => {
  const { getRevenueApi } = API_ROUTES;
  const { refreshToken } = useAppSelector((store) => store.user);
  const { currentBusiness } = useAppSelector((store) => store.business);
  const [selectedMonth, setSelectedMonth] = useState<number | string>(
    new Date().getMonth()
  );
  const [selectedYear, setSelectedYear] = useState<number | string>(
    new Date().getFullYear()
  );
  const [monthRang, setMonthRang] = useState<any[]>([]);
  // const monthRang = monthsData.filter((m) => {
  //   return m.value <= new Date().getMonth().toString() || m.value === "YTD" || m.value === selectedYear;
  // });
  const yearRang = monthsData.filter((m) => {
    return m.value === "YTD";
  });
  const [revenue, setRevenue] = useState<{
    total_revenue: string;
    total_cost: string;
    profit: string;
  }>({ total_cost: "0", total_revenue: "0", profit: "0" });
  useEffect(() => {
    (async () => {
      try {
        const res = await GET(
          `${getRevenueApi}?business_id=${currentBusiness}&month=${selectedMonth}&year=${selectedYear}`,
          refreshToken
        );
        setRevenue(res.data.data);
      } catch (error) {
        console.log(error);
      }
    })();
    console.log(
      "new Date().getMonth().toString()",
      new Date().getMonth().toString()
    );
    setMonthRang(
      monthsData.filter((m) => {
        if (selectedYear.toString() == new Date().getFullYear().toString()) {
          return (
            m.value <= new Date().getMonth().toString() || m.value === "YTD"
          );
        } else {
          return m
          // return Number(m.value ) - 1 || m.value == 'YTD'
        }
      })
    );
  }, [selectedMonth, currentBusiness, selectedYear]);
  return (
    <div>
      <div className=" flex gap-6 py-4 items-stretch md:flex-nowrap flex-wrap ">
        {/* left */}
        <div className=" md:w-8/12 w-full min-h-[95vh] ">
          {/* Top Cards */}
          <div className="flex gap-2 rounded-2xl  p-5 items-start bg-white justify-between sm:flex-row flex-col-reverse">
            <div className=" i relative rounded-2xl w-full">
              <div className=" flex gap-3 md:tems-start   justify-around  items-center flex-wrap w-full">
                <div className=" px-12  bg-p-gray  py-5 rounded-2xl text-center font-semibold min-w-44">
                  <p className="text-[30px] ">
                    $
                    {USFormatePriceWithoutDecimal(
                      centsToDollars(revenue.total_revenue)
                    )}
                  </p>
                  <p className="text-primary-red  text-sm">Revenue</p>
                </div>
                <div className="bg-p-gray  px-12  py-5 rounded-2xl text-center font-semibold min-w-44">
                  <p className="text-[30px] ">
                    $
                    {USFormatePriceWithoutDecimal(
                      centsToDollars(revenue.total_cost)
                    )}
                  </p>
                  <p className="text-primary-red  text-sm">Cost</p>
                </div>
                <div className="bg-p-gray  px-12   py-5 rounded-2xl text-center font-semibold min-w-44">
                  <p className="text-[30px] ">
                    $
                    {USFormatePriceWithoutDecimal(
                      centsToDollars(revenue.profit)
                    )}
                  </p>
                  <p className="text-primary-red  text-sm">Profit</p>
                </div>
              </div>
            </div>
            <div className="w-full gap-6 flex flex-col justify-between sm:w-fit">
              <select
                className="select-wrapper text-xs rounded-full cursor-pointer  focus:outline-none  focus:ring-1 focus:ring-primary-red"
                onChange={(e) => {
                  setSelectedYear(e.target.value);
                }}
                value={selectedYear}
              >
                {yearData.map((r: any) => {
                  return (
                    <option key={r.value} value={r.value}>
                      {r.label}
                    </option>
                  );
                })}
              </select>
              <select
                className="select-wrapper text-xs rounded-full cursor-pointer  focus:outline-none  focus:ring-1 focus:ring-primary-red"
                onChange={(e) => {
                  setSelectedMonth(e.target.value);
                }}
                value={selectedMonth}
              >
                {monthRang.map((r: any) => {
                  return (
                    <option key={r.value} value={r.value}>
                      {r.label}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>

          <div className="mt-7 ">
            <RevenueChart />
          </div>
        </div>
        {/* right */}
        <div className="md:w-4/12 w-full bg-white rounded-2xl overflow-y-auto max-h-[95vh] sm:max-h-[90vh] md:max-h-[140vh] lg:max-h-[150vh] xl:max-h-[95vh] 2xl:max-h-[90vh]">
          <UpcomingBooking />
        </div>
      </div>
      <div className="mt-4">
        <PackagePriceCalculator />
      </div>
    </div>
  );
};

function centsToDollars(cents: string) {
  // Convert cents to integer, divide by 100, then convert to string
  return Math.floor(parseInt(cents, 10) / 100).toString();
}
